module.exports = __webpack_public_path__ + "static/media/Through the Sunset.39bc07d8.jpg";